export const getSkeletonClassName = (data) => {
  return !data ? "skeleton-box" : "";
};
